import { useCallback, useReducer, useState } from 'react'
import {
  estadoQualidadeInicial,
  nivelForcadoDaBusca,
  reduzirQualidade,
  type NivelQualidade,
} from './qualidadeGrafica'

export interface QualidadeAdaptativa {
  readonly nivel: NivelQualidade
  /** Tela de toque (celular ou tablet): começa em `media`. */
  readonly celular: boolean
  /** `false` quando o nível foi fixado por `?qualidade=` e o monitor não deve atuar. */
  readonly adaptativa: boolean
  readonly aoDecair: () => void
  readonly aoSubir: () => void
}

/** Ponteiro grosso é dedo: celular ou tablet, onde a GPU é a mais curta da sala. */
function lerCelular(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia('(pointer: coarse)').matches
}

function lerNivelForcado(): NivelQualidade | null {
  if (typeof window === 'undefined') return null
  return nivelForcadoDaBusca(window.location.search)
}

/**
 * O estado vive no React, fora do `<Canvas>`, e não no store do R3F: o
 * `<Canvas dpr>` reaplica a prop a cada render, então um `setDpr` feito de
 * dentro seria desfeito no render seguinte. Quem manda no DPR é a prop.
 */
export function useQualidadeAdaptativa(): QualidadeAdaptativa {
  const [forcado] = useState(lerNivelForcado)
  const [celular] = useState(lerCelular)
  const [estado, despachar] = useReducer(reduzirQualidade, celular, estadoQualidadeInicial)

  const aoDecair = useCallback(() => despachar('decair'), [])
  const aoSubir = useCallback(() => despachar('subir'), [])

  return {
    nivel: forcado ?? estado.nivel,
    celular,
    adaptativa: forcado === null,
    aoDecair,
    aoSubir,
  }
}
